import { styled as t, Box as l, Typography as o } from "@mui/material";
import * as a from "ramda-adjunct";
import { jsxs as m, jsx as i } from "react/jsx-runtime";
const h = t(l)`
  display: flex;
  flex-direction: column;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    gap: 8px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    gap: 12px;
  }
`, c = t(o)`
  color: #b2b2b2;
  font-family: var(--font-Apeiron);
  line-height: 1;
  margin-bottom: -0.4em;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 30px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 20px;
  }
`, x = t(o)`
  color: white;
  font-weight: 700;
  line-height: 1;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 56px;
    line-height: 56px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 30px;
    line-height: 30px;
  }
`, f = t(o)`
  color: white;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  margin-top: -10px;
`, u = (e) => {
  const {
    apeironTitle: r,
    className: p,
    subtitle: n = "",
    title: s
  } = e;
  return /* @__PURE__ */ m(h, {
    className: p,
    children: [/* @__PURE__ */ i(c, {
      className: "Custom-Apeiron-Title",
      children: r || s
    }), /* @__PURE__ */ i(x, {
      className: "Custom-Title",
      children: s
    }), a.isNotNilOrEmpty(n) && /* @__PURE__ */ i(f, {
      className: "Custom-Subtitle",
      children: n
    })]
  });
};
export {
  u as default
};
//# sourceMappingURL=ApeironSectionTitle.js.map
